import React, { useState, useEffect, useCallback } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import * as Yup from "yup";
import toast, { Toaster } from "react-hot-toast";
import DefaultForm from "./DefaultForm";
import FormCompany from "./FormCompany";

function Registrate() {
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const history = useHistory();
  const [vroles, setVroles] = useState("");

  const checkEmailExists = useCallback(async (email, setFieldError) => {
    const res = await axios.get("user/exists/email/" + email);
    if (res.data?.exists) {
      setFieldError("email", "Email ya existe");
      return true;
    }
    return false;
  }, []);

  const checkUserExists = useCallback(async (username, setFieldError) => {
    const res = await axios.get("user/exists/username/" + username);
    if (res.data?.exists) {
      setFieldError("username", "usuario ya existe");
      return true;
    }
    return false;
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  });

  function convertoArray(item) {
    let array = [];
    for (var p in item) {
      if (item.hasOwnProperty(p)) {
        let rol = { value: "", desc: "" };
        rol.value = p;
        rol.desc = item[p];

        array.push(rol);
      }
    }
    setRoles(array);
  }

  useEffect(() => {
    toast.dismiss();
    const getRoles = async () => {
      await axios
        .get("access/roles")
        .then((result) => {
          if (result.status === 200) {
            convertoArray(result.data.roles);
            setLoading(false);
          } else if (result.status === 400) {
            toast.error(
              result.errors[0].field + " " + result.errors[0].defaultMessage
            );
          } else toast.error(result.message);
        })
        .catch((e) => {
          if (!e.status) {
            toast.error(
              "Problemas para conectarse al servidor, favor verifique su conexion e intentelo nuevamente",
              { duration: 5000 }
            );
          }
          setLoading(false);
        });
    };
    getRoles();
  }, []);

  async function postRegister(values, setFieldError) {
    //eliminamos los toast existentes
    toast.dismiss();
    //Procedemos a crear el array de roles ya que el backend asi lo esperagit
    //Procedemos a crear el array de roles ya que el backend asi lo espera
    const arrRoles = [];

    let userOrEmailExists = await Promise.all([
      checkEmailExists(values.email, setFieldError),
      checkUserExists(values.username, setFieldError),
    ]);

    if (userOrEmailExists.some((elm) => elm === true)) {
      return;
    }

    if (values.role === "otro") {
      arrRoles.push("otro");
    } else {
      let roleT = roles.find((item) => item.value === values.role);
      arrRoles.push(roleT.value);
    }

    const newemail = values.email.trim().toLowerCase();

    axios
      .post("auth/signup", {
        username: values.username,
        name: values.fullName,
        password: values.password,
        email: newemail,
        telephone: values.telephone,
        rol: arrRoles,
      })
      .then((result) => {
        if (result.status === 200) {
          localStorage.clear();

          setTimeout(() => {
            toast.success(result.data.message, {
              duration: 6000,
            });
          }, 900);
          history.push("/Login");
        }
      })
      .catch(function (error) {
        if (error.response.status === 400) {
          toast.error(error.response.data.errors[0].defaultMessage);
          setFieldError(
            error.response.data.errors[0].field,
            error.response.data.errors[0].defaultMessage
          );
        }
        if (error.response.status === 406) {
          toast.error(error.response.data.message);
          setFieldError(error.response.data.field, error.response.data.message);
        }
      });
  }

  const Validaciones = Yup.object().shape({
    username: Yup.string()
      .required("No puede estar vacio")
      .min(3, "No puede tener menos de 3 caracteres")
      .max(60, "Maximo de 60 caracteres"),
    password: Yup.string()
      .required("No puede estar vacio")
      .min(8, "No puede tener menos de 8 caracteres"),
    confirmPassword: Yup.string()
      .required("No puede estar vacio")
      .min(8, "No puede tener menos de 8 caracteres")
      .oneOf([Yup.ref("password"), null], "Las contrasenas no coinciden"),
    role: Yup.string().required("Debe seleccionar uno"),
    fullName: Yup.string().required("No puede estar vacio"),
    legalRepresentativeName: Yup.string().required("No puede estar vacio"),
    companyName: Yup.string().required("No puede estar vacio"),
    companyAddress: Yup.string().required("No puede estar vacio"),
    companyEmail: Yup.string()
      .required("No puede estar vacio")
      .email("Correo Invalido"),
    email: Yup.string()
      .required("No puede estar vacio")
      .email("Correo Invalido"),
    telephone: Yup.number()
      .integer("No puede tener decimales")
      .min(8, "No puede ser negativo"),
    companyPhone: Yup.number()
      .integer("No puede tener decimales")
      .min(8, "No puede ser negativo")
      .typeError("No debe incluir caracteres alfabéticos"),
    companyCellphone: Yup.number()
      .integer("No puede tener decimales")
      .min(8, "No puede ser negativo")
      .typeError("No debe incluir caracteres alfabéticos"),
    companyRuc: Yup.string().required("No puede estar vacio"),
    companyCommercialName: Yup.string().required("No puede estar vacio"),
    contactName: Yup.string().required("No puede estar vacio"),
    contactId: Yup.string()
      .required("No puede estar vacio")
      .min(14, "Ingrese Número de cédula Valido"),
    companyVision: Yup.string().required("No puede estar vacio"),
    companyMission: Yup.string().required("No puede estar vacio"),
    companySector: Yup.string().required("No puede estar vacio"),
  });

  function mostrarPassword() {
    var cambio = document.getElementById("password");
    cambio.type === "password"
      ? (cambio.type = "text")
      : (cambio.type = "password");
  }

  const forms = {
    company: <FormCompany {...{ setVroles, roles, loading, vroles }} />,
  };

  const defaultFormProps = {
    loading,
    postRegister,
    Validaciones,
    roles,
    mostrarPassword,
    vroles,
    setVroles,
  };

  return (
    <div className="login">
      <Toaster />
      <div className="container">
        <div className="row">
          <div className="col-sm-12 align-div--middle">
            <div className="login__content-wrapper">
              <div className="logo">KREZCO</div>
              {forms[vroles] ?? <DefaultForm {...defaultFormProps} />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Registrate;
